<template>
  <unlockComponent :unlockDetails="classicalUnlock" :paramValue="'Classical-Upgrade'"/>
</template>
<script>
import unlockComponent from "@/components/upgrade/UnlockComponent.vue";
import { ref, onMounted } from "vue";
import { getClassicalUnlock } from "@/services/classical.js";

export default {
  name: "classical-status",
  setup() {
    const classicalUnlock = ref(null); // Define classicalUpgrade as a ref

    onMounted(async () => {
      classicalUnlock.value = await getClassicalUnlock();
    });

    return {
      classicalUnlock,
    };
  },
  components: { unlockComponent },
};
</script>